import { NgModule } from '@angular/core';
import { AngularDayjsService } from './angular-dayjs.service';

@NgModule({
  providers: [AngularDayjsService],
})
export class AngularDayjsModule {}
